import styled, {css} from "styled-components";

export const SectionContainer = styled.section`
	width: 100vw;
	height: 100vh;
	position: relative;
	&:after {
		content: '';
		position: absolute;
		top: inherit;
		left: inherit;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
	}
`;

export const BackgroundImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: 50% 50%;
`;

export const ContentContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 10%;
	z-index: 5;
	transform: translateY(-25%);
	width: 80%;
	max-width: 100rem;
	// text-transform: uppercase;
	${(props) =>
		props.centeredText &&
		css`
			text-align: center;
			left: 50%;
			transform: translate(-50%, -50%);
		`}
`;

export const Title = styled.h2`
margin-top:0.5em;
line-height:1.2em;
font-size:5rem;
${theme => theme.mobile} {
    font-size: 3.5rem;
}
`;

export const Subtitle = styled.p`
line-height:1.2em;
font-size:2.5rem;
font-weight: 1000;
${theme => theme.mobile} {
    font-size: 2.3rem;
	text-align:justify;
}
`;

export const Button = styled.button`	  
	margin:0 auto;
	border-radius: 50px;
	font-size: 16px;
  	font-weight: 700;
  	padding: 15px 60px;
	cursor:pointer;
	background-color: ${({ bg }) => bg || '#fff'};
  	color: ${({ color }) => color || '#333'};

	&:hover {
		opacity: 0.9;		
		transform: scale(0.98);
	}

	${theme => theme.mobile} {
		margin-top:.5em;
	}

`;

export const Tag = styled.div`
	display: inline-block;
	// font-size: 3rem;	
	font-weight: 700;
	letter-spacing: 0.2rem;
	padding-left: 4rem;
	positon: relative;
	&:before {
		// background-color: #03d;
		content: '';
		display: block;
		height: 0.5rem;
		width: 2.5rem;
		position: absolute;
		top: 0.5rem;
		left: 0;
	}

	${theme => theme.mobile} {
		font-size:2.5rem;
	}
`;